import { render, staticRenderFns } from "./BackEdit.vue?vue&type=template&id=0cd5c30c&scoped=true&"
import script from "./BackEdit.vue?vue&type=script&lang=js&"
export * from "./BackEdit.vue?vue&type=script&lang=js&"
import style0 from "./BackEdit.vue?vue&type=style&index=0&id=0cd5c30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5c30c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd5c30c')) {
      api.createRecord('0cd5c30c', component.options)
    } else {
      api.reload('0cd5c30c', component.options)
    }
    module.hot.accept("./BackEdit.vue?vue&type=template&id=0cd5c30c&scoped=true&", function () {
      api.rerender('0cd5c30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/edit/BackEdit.vue"
export default component.exports